import { FunctionComponent } from "react";
import { connect } from "react-redux";
import {
  invocate,
  changePath,
  submitPaymentIntent,
  updatePaymentIntent,
  setIsProcessingPayment,
  PaymentDetailsProps,
  fetchPaymentDetails,
} from "./actions";

export type SelectedBusiness = {
  name: string;
  uuid: string;
};

export type SelectedSubCat = {
  title: string;
  uuid: string;
};

export type SelectedWidget = {
  label: string;
  uuid: string;
  price: number;
};

export type Invocations = {
  [key: string]: string | SelectedSubCat | SelectedBusiness | SelectedWidget;
};

export type Publisher = {
  newspaper_url: string;
  newspaper_name: string;
  cdn_logo_url: string;
  url: string;
  country: string;
  enabled_layouts: number[];
};

export type WizardProps = {
  invocations: Invocations;
  publisher: Publisher;
  invocate: Function;
  changePath: Function;
  submitPaymentIntent: Function;
  updatePaymentIntent: Function;
  fetchPaymentDetails: Function;
  setIsProcessingPayment: Function;
  isProcessingPayment: boolean;
  paymentDetails: PaymentDetailsProps;
};

type ReducerProps = {
  wizard: {
    invocations: Invocations;
    isProcessingPayment: boolean;
    paymentDetails: PaymentDetailsProps;
    publisher: Publisher;
  };
};
const mapStateToProps = ({
  wizard: { invocations, paymentDetails, publisher, isProcessingPayment },
}: ReducerProps) => ({
  invocations,
  publisher,
  paymentDetails,
  isProcessingPayment,
});

const wizardContainer = (Component: FunctionComponent<WizardProps>) =>
  connect(mapStateToProps, {
    invocate,
    changePath,
    submitPaymentIntent,
    updatePaymentIntent,
    setIsProcessingPayment,
    fetchPaymentDetails,
  })(Component);

export default wizardContainer;
